const SHOP_JOB_ISO_INSTANT =
  /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}(?::\d{2}(?:\.\d+)?)?(?:Z|[+-]\d{2}:?\d{2})$/i;
const SHOP_JOB_DEFAULT_TIMEZONE = "America/Denver";

function shopJobIanaTimezone(value) {
  if (typeof value === "string" && value.trim()) {
    try {
      new Intl.DateTimeFormat("en-US", { timeZone: value.trim() }).format();
      return value.trim();
    } catch (error) {
      /* invalid IANA name */
    }
  }
  return SHOP_JOB_DEFAULT_TIMEZONE;
}

function shopJobCalendarDay(date, timeZone) {
  const parts = new Intl.DateTimeFormat("en-US", {
    timeZone: shopJobIanaTimezone(timeZone),
    year: "numeric",
    month: "numeric",
    day: "numeric",
  }).formatToParts(date);
  const num = (type) =>
    Number(parts.find((part) => part.type === type)?.value);
  const year = num("year");
  const month = num("month");
  const day = num("day");
  if (!Number.isFinite(year) || !Number.isFinite(month) || !Number.isFinite(day)) {
    return null;
  }
  return (
    String(year).padStart(4, "0") +
    "-" +
    String(month).padStart(2, "0") +
    "-" +
    String(day).padStart(2, "0")
  );
}

/** Calendar day of an ISO instant in the job timezone. Legacy strings stay on the prefix slice. */
export function shopJobDateLabel(job) {
  const value = job && job.date;
  if (typeof value !== "string") return value;
  if (!SHOP_JOB_ISO_INSTANT.test(value)) return value.slice(0, 10);
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return value.slice(0, 10);
  const rawZone = job.timezone ?? job.timeZone;
  const zone = typeof rawZone === "string" ? rawZone : "";
  return shopJobCalendarDay(date, zone) ?? value.slice(0, 10);
}
